function extensionFromFileName(fileName) {
    return String(fileName || '').replace(/^.*\./, '').toLowerCase();
}

export function checkLoadedFileImage(fileName) {
    return ['jpeg', 'jpg', 'png', 'bmp', 'gif', 'svg'].includes(extensionFromFileName(fileName));
}
